import React from 'react'

const RadioIcon = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='0.5' y='0.5' width='19' height='19' rx='9.5' fill='white' stroke='#A1A1AA' />
    </svg>
  )
}

export default RadioIcon
